import { FilterOperator } from "@/lib/filters/FilterOperator";

/**
 * Checks if a value is a valid filter operator.
 */
export const isFilterOperator = (value: string): value is FilterOperator =>
  Object.values(FilterOperator).includes(value as FilterOperator);
